import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { Observable } from 'rxjs';
import { SampleTaskNavigationService } from '../services/sample-task-navigation.service';
import { SamplingWorkspaceStore } from '../state/sampling-workspace-store';

@Component({
  selector: 'h3-sampling-workspace-nav',
  templateUrl: './sampling-workspace-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamplingWorkspaceNavComponent {
  @Input({ required: true }) pagePosition!: 'header' | 'footer';
  positionStore: Store<number>;
  taskCount$: Observable<number>;

  private navigationService = inject(SampleTaskNavigationService);
  private navigateTo = this.navigationService.navigateTo.bind(
    this.navigationService,
  );

  constructor(samplingWorkspaceStore: SamplingWorkspaceStore) {
    this.positionStore = samplingWorkspaceStore('position');
    this.taskCount$ = samplingWorkspaceStore('sample')('sampledTaskCount').$;
  }

  go() {
    this.navigateTo(0, 'go_button', this.pagePosition);
  }

  next() {
    this.navigateTo(1, 'next_button', this.pagePosition);
  }

  previous() {
    this.navigateTo(-1, 'previous_button', this.pagePosition);
  }
}
